import "./App.css";
import { AllRoutes } from "./Component/AllRoutes";

function App() {
  return (
    <div className="App">
      <AllRoutes />
    </div>
  );
}

export default App;
